import React, { useContext } from 'react';

import { Link } from '@jutro/components';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './ClaimFnolInfoTemplate.metadata.json5';
import messages from './ClaimFnolInfoTemplate.messages';


function ClaimFnolInfoTemplate() {

    const translator = useContext(TranslatorContext);

    const phoneToTrigger = (event, phone) => {
        event.preventDefault();
        window.location = `tel:${phone}`;
    };

    const getNoteContent = (phoneNo) => {
        /*if (_.isEmpty(phoneNo)) {
            return translator(messages.fnolClaimInfoTextAll);
        }*/
        return (
            <span>
                <p>
                    {translator(messages.fnolClaimInfoText2)}
                    <Link onClick={(e) => phoneToTrigger(e, phoneNo)} href="/">
                        {phoneNo}
                    </Link>
                    {/*{translator(messages.fnolClaimInfoText3)}*/}
                </p>
            </span>
        );
    };


    const overrides = {
        fnolInfoText2: {
            content: getNoteContent('1-800-265-8813')
        },

    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrides}
        />
    );
}

export default ClaimFnolInfoTemplate;
